export type User = {
	email: string;
	language: string;
	role: string;
	onboarding_completed?: boolean;
	organization: Organization;
};

export type Organization = {
	id: string;
	name: string;
	organizationType: string;
	products: string[];
};

export const defaultUser: User = {
	email: "",
	language: "es_ES",
	role: "",
	onboarding_completed: true,
	organization: { id: "test", name: "", organizationType: "", products: [] }
};
